import { render, staticRenderFns } from "./EmbedImageModal.vue?vue&type=template&id=4f97d7ee"
import script from "./EmbedImageModal.vue?vue&type=script&lang=js"
export * from "./EmbedImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports